###
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
###

CKEDITOR.lang['ru'] =
  'wsc':
    'btnIgnore': 'Пропустить'
    'btnIgnoreAll': 'Пропустить всё'
    'btnReplace': 'Заменить'
    'btnReplaceAll': 'Заменить всё'
    'btnUndo': 'Отменить'
    'changeTo': 'Изменить на'
    'errorLoading': 'Произошла ошибка при подключении к серверу проверки орфографии: %s.'
    'ieSpellDownload': 'Модуль проверки орфографии не установлен. Хотите скачать его?'
    'manyChanges': 'Проверка орфографии завершена. Изменено слов: %1'
    'noChanges': 'Проверка орфографии завершена. Не изменено ни одного слова'
    'noMispell': 'Проверка орфографии завершена. Ошибок не найдено'
    'noSuggestions': '- Варианты отсутствуют -'
    'notAvailable': 'Извините, но в данный момент сервис недоступен.'
    'notInDic': 'Отсутствует в словаре'
    'oneChange': 'Проверка орфографии завершена. Изменено одно слово'
    'progress': 'Орфография проверяется...'
    'title': 'Проверка орфографии'
    'toolbar': 'Проверить орфографию'
  'undo':
    'redo': 'Повторить'
    'undo': 'Отменить'
  'toolbar':
    'toolbarCollapse': 'Свернуть панель инструментов'
    'toolbarExpand': 'Развернуть панель инструментов'
    'toolbarGroups':
      'document': 'Документ'
      'clipboard': 'Буфер обмена / Отмена действий'
      'editing': 'Корректировка'
      'forms': 'Формы'
      'basicstyles': 'Простые стили'
      'paragraph': 'Абзац'
      'links': 'Ссылки'
      'insert': 'Вставка'
      'styles': 'Стили'
      'colors': 'Цвета'
      'tools': 'Инструменты'
    'toolbars': 'Панели инструментов редактора'
  'table':
    'border': 'Размер границ'
    'caption': 'Заголовок'
    'cell':
      'menu': 'Ячейка'
      'insertBefore': 'Вставить ячейку слева'
      'insertAfter': 'Вставить ячейку справа'
      'deleteCell': 'Удалить ячейки'
      'merge': 'Объединить ячейки'
      'mergeRight': 'Объединить с правой'
      'mergeDown': 'Объединить с нижней'
      'splitHorizontal': 'Разделить ячейку по горизонтали'
      'splitVertical': 'Разделить ячейку по вертикали'
      'title': 'Свойства ячейки'
      'cellType': 'Тип ячейки'
      'rowSpan': 'Объединяет строк'
      'colSpan': 'Объединяет колонок'
      'wordWrap': 'Перенос по словам'
      'hAlign': 'Горизонтальное выравнивание'
      'vAlign': 'Вертикальное выравнивание'
      'alignBaseline': 'По базовой линии'
      'bgColor': 'Цвет фона'
      'borderColor': 'Цвет границ'
      'data': 'Данные'
      'header': 'Заголовок'
      'yes': 'Да'
      'no': 'Нет'
      'invalidWidth': 'Ширина ячейки должна быть числом.'
      'invalidHeight': 'Высота ячейки должна быть числом.'
      'invalidRowSpan': 'Количество объединяемых строк должно быть задано числом.'
      'invalidColSpan': 'Количество объединяемых колонок должно быть задано числом.'
      'chooseColor': 'Выберите'
    'cellPad': 'Внутренний отступ ячеек'
    'cellSpace': 'Внешний отступ ячеек'
    'column':
      'menu': 'Колонка'
      'insertBefore': 'Вставить колонку слева'
      'insertAfter': 'Вставить колонку справа'
      'deleteColumn': 'Удалить колонки'
    'columns': 'Колонки'
    'deleteTable': 'Удалить таблицу'
    'headers': 'Заголовки'
    'headersBoth': 'Сверху и слева'
    'headersColumn': 'Левая колонка'
    'headersNone': 'Без заголовков'
    'headersRow': 'Верхняя строка'
    'invalidBorder': 'Размер границ должен быть числом.'
    'invalidCellPadding': 'Внутренний отступ ячеек (cellpadding) должен быть числом.'
    'invalidCellSpacing': 'Внешний отступ ячеек (cellspacing) должен быть числом.'
    'invalidCols': 'Количество столбцов должно быть больше 0.'
    'invalidHeight': 'Высота таблицы должна быть числом.'
    'invalidRows': 'Количество строк должно быть больше 0.'
    'invalidWidth': 'Ширина таблицы должна быть числом.'
    'menu': 'Свойства таблицы'
    'row':
      'menu': 'Строка'
      'insertBefore': 'Вставить строку сверху'
      'insertAfter': 'Вставить строку снизу'
      'deleteRow': 'Удалить строки'
    'rows': 'Строки'
    'summary': 'Итоги'
    'title': 'Свойства таблицы'
    'toolbar': 'Таблица'
    'widthPc': 'процентов'
    'widthPx': 'пикселей'
    'widthUnit': 'единица измерения'
  'stylescombo':
    'label': 'Стили'
    'panelTitle': 'Стили форматирования'
    'panelTitle1': 'Стили блока'
    'panelTitle2': 'Стили элемента'
    'panelTitle3': 'Стили объекта'
  'specialchar':
    'options': 'Выбор специального символа'
    'title': 'Выберите специальный символ'
    'toolbar': 'Вставить специальный символ'
  'sourcearea': 'toolbar': 'Источник'
  'scayt':
    'btn_about': 'О SCAYT'
    'btn_dictionaries': 'Словари'
    'btn_disable': 'Отключить SCAYT'
    'btn_enable': 'Включить SCAYT'
    'btn_langs': 'Языки'
    'btn_options': 'Настройки'
    'text_title': 'Проверка орфографии по мере ввода (SCAYT)'
  'removeformat': 'toolbar': 'Убрать форматирование'
  'pastetext':
    'button': 'Вставить только текст'
    'title': 'Вставить только текст'
  'pastefromword':
    'confirmCleanup': 'Текст, который вы желаете вставить, по всей видимости, был скопирован из Word. Следует ли очистить его перед вставкой?'
    'error': 'Невозможно очистить вставленные данные из-за внутренней ошибки'
    'title': 'Вставить из Word'
    'toolbar': 'Вставить из Word'
  'maximize':
    'maximize': 'Развернуть'
    'minimize': 'Свернуть'
  'magicline': 'title': 'Вставить здесь параграф'
  'list':
    'bulletedlist': 'Вставить / удалить маркированный список'
    'numberedlist': 'Вставить / удалить нумерованный список'
  'link':
    'acccessKey': 'Клавиша доступа'
    'advanced': 'Дополнительно'
    'advisoryContentType': 'Тип содержимого'
    'advisoryTitle': 'Заголовок'
    'anchor':
      'toolbar': 'Вставить / редактировать якорь'
      'menu': 'Изменить якорь'
      'title': 'Свойства якоря'
      'name': 'Имя якоря'
      'errorName': 'Пожалуйста, введите имя якоря'
      'remove': 'Удалить якорь'
    'anchorId': 'По идентификатору'
    'anchorName': 'По имени'
    'charset': 'Кодировка ресурса'
    'cssClasses': 'Классы CSS'
    'emailAddress': 'Email адрес'
    'emailBody': 'Текст сообщения'
    'emailSubject': 'Тема сообщения'
    'id': 'Идентификатор'
    'info': 'Информация о ссылке'
    'langCode': 'Код языка'
    'langDir': 'Направление текста'
    'langDirLTR': 'Слева направо (LTR)'
    'langDirRTL': 'Справа налево (RTL)'
    'menu': 'Редактировать ссылку'
    'name': 'Имя'
    'noAnchors': '(В документе нет ни одного якоря)'
    'noEmail': 'Пожалуйста, введите email адрес'
    'noUrl': 'Пожалуйста, введите ссылку'
    'other': '<другой>'
    'popupDependent': 'Зависимое (Netscape)'
    'popupFeatures': 'Параметры всплывающего окна'
    'popupFullScreen': 'Полноэкранное (IE)'
    'popupLeft': 'Отступ слева'
    'popupLocationBar': 'Панель адреса'
    'popupMenuBar': 'Панель меню'
    'popupResizable': 'Изменяемый размер'
    'popupScrollBars': 'Полосы прокрутки'
    'popupStatusBar': 'Строка состояния'
    'popupToolbar': 'Панель инструментов'
    'popupTop': 'Отступ сверху'
    'rel': 'Отношение'
    'selectAnchor': 'Выберите якорь'
    'styles': 'Стиль'
    'tabIndex': 'Последовательность перехода'
    'target': 'Цель'
    'targetFrame': '<фрейм>'
    'targetFrameName': 'Имя целевого фрейма'
    'targetPopup': '<всплывающее окно>'
    'targetPopupName': 'Имя всплывающего окна'
    'title': 'Ссылка'
    'toAnchor': 'Ссылка на якорь в тексте'
    'toEmail': 'Email'
    'toUrl': 'Ссылка'
    'toolbar': 'Вставить/Редактировать ссылку'
    'type': 'Тип ссылки'
    'unlink': 'Убрать ссылку'
    'upload': 'Загрузка'
  'indent':
    'indent': 'Увеличить отступ'
    'outdent': 'Уменьшить отступ'
  'image':
    'alertUrl': 'Пожалуйста, введите ссылку на изображение'
    'alt': 'Альтернативный текст'
    'border': 'Граница'
    'btnUpload': 'Загрузить на сервер'
    'button2Img': 'Вы желаете преобразовать это изображение-кнопку в обычное изображение?'
    'hSpace': 'Гориз. отступ'
    'img2Button': 'Вы желаете преобразовать это обычное изображение в изображение-кнопку?'
    'infoTab': 'Данные об изображении'
    'linkTab': 'Ссылка'
    'lockRatio': 'Сохранять пропорции'
    'menu': 'Свойства изображения'
    'resetSize': 'Вернуть обычные размеры'
    'title': 'Свойства изображения'
    'titleButton': 'Свойства изображения-кнопки'
    'upload': 'Загрузить'
    'urlMissing': 'Не указана ссылка на изображение.'
    'vSpace': 'Вертик. отступ'
    'validateBorder': 'Размер границ должен быть задан числом.'
    'validateHSpace': 'Горизонтальный отступ должен быть задан числом.'
    'validateVSpace': 'Вертикальный отступ должен быть задан числом.'
  'horizontalrule': 'toolbar': 'Вставить горизонтальную линию'
  'format':
    'label': 'Форматирование'
    'panelTitle': 'Форматирование'
    'tag_address': 'Адрес'
    'tag_div': 'Обычное (div)'
    'tag_h1': 'Заголовок 1'
    'tag_h2': 'Заголовок 2'
    'tag_h3': 'Заголовок 3'
    'tag_h4': 'Заголовок 4'
    'tag_h5': 'Заголовок 5'
    'tag_h6': 'Заголовок 6'
    'tag_p': 'Параграф'
    'tag_pre': 'Моноширинное'
  'fakeobjects':
    'anchor': 'Якорь'
    'flash': 'Flash анимация'
    'hiddenfield': 'Скрытое поле'
    'iframe': 'iFrame'
    'unknown': 'Неизвестный объект'
  'elementspath':
    'eleLabel': 'Путь элементов'
    'eleTitle': 'Элемент %1'
  'contextmenu': 'options': 'Параметры контекстного меню'
  'clipboard':
    'copy': 'Копировать'
    'copyError': 'Настройки безопасности вашего браузера не разрешают редактору выполнять операции по копированию текста. Пожалуйста, используйте для этого клавиатуру (Ctrl/Cmd+C).'
    'cut': 'Вырезать'
    'cutError': 'Настройки безопасности вашего браузера не разрешают редактору выполнять операции по вырезке текста. Пожалуйста, используйте для этого клавиатуру (Ctrl/Cmd+X).'
    'paste': 'Вставить'
    'pasteArea': 'Зона для вставки'
    'pasteMsg': 'Пожалуйста, вставьте текст в зону ниже, используя клавиатуру (<strong>Ctrl/Cmd+V</strong>) и нажмите кнопку "OK".'
    'securityMsg': 'Настройки безопасности вашего браузера не разрешают редактору напрямую обращаться к буферу обмена. Вы должны вставить текст снова в это окно.'
    'title': 'Вставить'
  'button': 'selectedLabel': '%1 (Выбрано)'
  'blockquote': 'toolbar': 'Цитата'
  'basicstyles':
    'bold': 'Полужирный'
    'italic': 'Курсив'
    'strike': 'Зачеркнутый'
    'subscript': 'Подстрочный индекс'
    'superscript': 'Надстрочный индекс'
    'underline': 'Подчеркнутый'
  'about':
    'copy': 'Copyright &copy; $1. Все права защищены.'
    'dlgTitle': 'О CKEditor'
    'help': '$1 содержит подробную справку по использованию.'
    'moreInfo': 'Для получения информации о лицензии, пожалуйста, перейдите на наш сайт:'
    'title': 'О CKEditor'
    'userGuide': 'Руководство пользователя CKEditor'
  'editor': 'Визуальный текстовый редактор'
  'editorPanel': 'Визуальный редактор текста'
  'common':
    'editorHelp': 'Нажмите ALT-0 для открытия справки'
    'browseServer': 'Выбор на сервере'
    'url': 'Ссылка'
    'protocol': 'Протокол'
    'upload': 'Загрузка файла'
    'uploadSubmit': 'Загрузить на сервер'
    'image': 'Изображение'
    'flash': 'Flash'
    'form': 'Форма'
    'checkbox': 'Чекбокс'
    'radio': 'Радиокнопка'
    'textField': 'Текстовое поле'
    'textarea': 'Многострочное текстовое поле'
    'hiddenField': 'Скрытое поле'
    'button': 'Кнопка'
    'select': 'Выпадающий список'
    'imageButton': 'Кнопка-изображение'
    'notSet': '<не указано>'
    'id': 'Идентификатор'
    'name': 'Имя'
    'langDir': 'Направление текста'
    'langDirLtr': 'Слева направо (LTR)'
    'langDirRtl': 'Справа налево (RTL)'
    'langCode': 'Код языка'
    'longDescr': 'Длинное описание ссылки'
    'cssClass': 'Класс CSS'
    'advisoryTitle': 'Заголовок'
    'cssStyle': 'Стиль'
    'ok': 'ОК'
    'cancel': 'Отмена'
    'close': 'Закрыть'
    'preview': 'Предпросмотр'
    'resize': 'Перетащите для изменения размера'
    'generalTab': 'Основное'
    'advancedTab': 'Дополнительно'
    'validateNumberFailed': 'Это значение не является числом.'
    'confirmNewPage': 'Несохранённые изменения будут потеряны! Вы действительно желаете перейти на другую страницу?'
    'confirmCancel': 'Некоторые параметры были изменены. Вы уверены, что желаете закрыть без сохранения?'
    'options': 'Параметры'
    'target': 'Цель'
    'targetNew': 'Новое окно (_blank)'
    'targetTop': 'Главное окно (_top)'
    'targetSelf': 'Текущее окно (_self)'
    'targetParent': 'Родительское окно (_parent)'
    'langDirLTR': 'Слева направо (LTR)'
    'langDirRTL': 'Справа налево (RTL)'
    'styles': 'Стиль'
    'cssClasses': 'CSS классы'
    'width': 'Ширина'
    'height': 'Высота'
    'align': 'Выравнивание'
    'alignLeft': 'По левому краю'
    'alignRight': 'По правому краю'
    'alignCenter': 'По центру'
    'alignJustify': 'По ширине'
    'alignTop': 'Поверху'
    'alignMiddle': 'Посередине'
    'alignBottom': 'Понизу'
    'alignNone': 'Нет'
    'invalidValue': 'Недопустимое значение.'
    'invalidHeight': 'Высота задается числом.'
    'invalidWidth': 'Ширина задается числом.'
    'invalidCssLength': 'Значение, указанное в поле "%1", должно быть положительным целым числом. Допускается указание единиц меры CSS (px, %, in, cm, mm, em, ex, pt или pc).'
    'invalidHtmlLength': 'Значение, указанное в поле "%1", должно быть положительным целым числом. Допускается указание единиц меры HTML (px или %).'
    'invalidInlineStyle': 'Значение, указанное для стиля элемента, должно состоять из одной или нескольких пар данных в формате "параметр : значение", разделённых точкой с запятой.'
    'cssLengthTooltip': 'Введите значение в пикселях, либо число с корректной единицей меры CSS (px, %, in, cm, mm, em, ex, pt или pc).'
    'unavailable': '%1<span class="cke_accessibility">, недоступно</span>'



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/lang/ru.coffee